import * as THREE from "three";
import { VehicleData } from "../types";

const DEG2RAD = Math.PI / 180;

export function createVehicle(data: VehicleData): THREE.Group {
  const car = new THREE.Group();

  const bodyMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(data.color),
    roughness: 0.4,
    metalness: 0.3,
  });

  const lowerGeo = new THREE.BoxGeometry(3.2, 0.6, 1.5);
  const lower = new THREE.Mesh(lowerGeo, bodyMat);
  lower.position.y = 0.4;
  lower.castShadow = true;
  car.add(lower);

  const upperGeo = new THREE.BoxGeometry(1.8, 0.55, 1.3);
  const upper = new THREE.Mesh(upperGeo, bodyMat);
  upper.position.set(-0.15, 0.95, 0);
  upper.castShadow = true;
  car.add(upper);

  const glassMat = new THREE.MeshStandardMaterial({
    color: 0xc8dce8,
    roughness: 0.15,
    metalness: 0.4,
    transparent: true,
    opacity: 0.6,
  });
  const windshieldGeo = new THREE.BoxGeometry(0.05, 0.45, 1.2);
  const wsFront = new THREE.Mesh(windshieldGeo, glassMat);
  wsFront.position.set(0.75, 0.95, 0);
  car.add(wsFront);
  const wsBack = new THREE.Mesh(windshieldGeo, glassMat);
  wsBack.position.set(-1.05, 0.95, 0);
  car.add(wsBack);

  const wheelGeo = new THREE.CylinderGeometry(0.25, 0.25, 0.2, 12);
  const wheelMat = new THREE.MeshStandardMaterial({
    color: 0x222222,
    roughness: 0.9,
  });
  const offsets: [number, number, number][] = [
    [1.0, 0.2, 0.85],
    [1.0, 0.2, -0.85],
    [-1.0, 0.2, 0.85],
    [-1.0, 0.2, -0.85],
  ];
  for (const [wx, wy, wz] of offsets) {
    const wheel = new THREE.Mesh(wheelGeo, wheelMat);
    wheel.rotation.x = Math.PI / 2;
    wheel.position.set(wx, wy, wz);
    wheel.castShadow = true;
    car.add(wheel);
  }

  car.position.set(...data.position);
  car.rotation.set(
    data.rotation[0] * DEG2RAD,
    data.rotation[1] * DEG2RAD,
    data.rotation[2] * DEG2RAD
  );

  return car;
}
